//发票管理相关 api
import request from '@/utils/request'
const baseService = 'autoapp-default-server-recovery'

/**
 * @function 查询签约列表
 * @param {object} data - 请求参数
 * @param {number} data.page - 页码
 * @param {number} data.rows - 每页条数
 * @param {string} data.signId - 签约单号
 * @param {string} data.userName - 用户名
 * @param {number[]} data.statusList - 状态列表
 * @param {string} data.idCard - 身份证
 * @param {string[]} data.signCompanyNameList - 签约公司列表
 * @param {string} data.signYear - 签约年份
 * @param {string} data.startSignTime - 开始签约时间
 * @param {string} data.endSignTime - 结束签约时间
 * @returns {Promise<object>}
 */
export function getSignPageList(data) {
  return request({
    url: `${baseService}/api/invoice/sign/pageCondition`,
    method: 'post',
    data
  })
}

/**
 * @function 查询开票额度分页
 * @param {object} data - 请求参数
 * @param {number} data.page - 页码
 * @param {number} data.rows - 每页条数
 * @param {string} data.userName - 用户名
 * @param {string} data.idCard - 身份证
 * @param {string[]} data.signCompanyNameList - 签约公司列表
 * @param {number} data.limitStatus - 发票额度状态
 * @returns {Promise<object>}
 */
export function getInvoiceInfoPageList(data) {
  return request({
    url: `${baseService}/api/invoice/info/pageCondition`,
    method: 'post',
    data
  })
}

/**
 * @function 开票额度新增
 * @param {object} data - 请求参数
 * @param {number} data.invoiceId - 发票订单号
 * @param {string} data.signCompanyName - 发票公司名称
 * @param {number} data.money - 发票额度
 * @param {string} data.date - 发票日期
 * @param {string} data.userName - 用户名称
 * @returns {Promise<object>}
 */
export function addInvoiceInfo(data) {
  return request({
    url: `${baseService}/api/invoice/info/apply`,
    method: 'post',
    data
  })
}

/**
 * @function 查询开票额度详情
 * @param {number} invoiceId - 发票订单号
 * @returns {Promise<object>}
 */
export function getInvoiceInfoDetail(invoiceId) {
  return request({
    url: `${baseService}/api/invoice/info/detailByInvoiceId/${invoiceId}`,
    method: 'get'
  })
}

/**
 * @function 开票额度更新
 * @param {object} data - 请求参数
 * @param {number} data.detailId - 发票额度详情ID
 * @param {string} data.signCompanyName - 发票公司名称
 * @param {number} data.money - 发票额度
 * @param {string} data.date - 发票日期
 * @returns {Promise<object>}
 */
export function updateInvoiceInfo(data) {
  return request({
    url: `${baseService}/api/invoice/info/update`,
    method: 'post',
    data
  })
}

/**
 * @function 新建签约
 * @param {object} data - 请求参数
 * @param {string} data.userName - 用户名
 * @param {string} data.phone - 手机号
 * @param {string} data.signCompanyName - 签约公司名称
 * @returns {Promise<object>}
 */
export function addSign(data) {
  return request({
    url: `${baseService}/api/invoice/sign/addSign`,
    method: 'post',
    data
  })
}

/**
 * @function 获取签约公司枚举
 * @returns {Promise<object>}
 */
export function getCompanyEnum() {
  return request({
    url: `${baseService}/api/invoice/common/getCompanyEnum`,
    method: 'get'
  })
}

/**
 * @function 获取签约链接
 * @param {object} data - 请求参数
 * @param {string} data.signId - 签约ID
 * @returns {Promise<object>}
 */
export function getSignUrl(data) {
  return request({
    url: `${baseService}/api/invoice/sign/getSignUrl`,
    method: 'post',
    data
  })
}

/**
 * @function 查询签约详情
 * @param {string} signId - 签约ID
 * @returns {Promise<object>}
 */
export function getSignDetail(signId) {
  return request({
    url: `${baseService}/api/invoice/sign/detailByAdmin/${signId}`,
    method: 'get'
  })
}

/**
 * @function 审批签约
 * @param {object} data - 请求参数
 * @param {string} data.signId - 签约号
 * @returns {Promise<object>}
 */
export function approveSign(data) {
  return request({
    url: `${baseService}/api/invoice/sign/approve`,
    method: 'post',
    data
  })
}

/**
 * @function 拒绝签约
 * @param {object} data - 请求参数
 * @param {string} data.signId - 签约号
 * @returns {Promise<object>}
 */
export function rejectSign(data) {
  return request({
    url: `${baseService}/api/invoice/sign/rejected`,
    method: 'post',
    data
  })
}

/**
 * @function 法务审批签约
 * @param {object} data - 请求参数
 * @param {string[]} data.signIds - 签约号数组
 * @returns {Promise<object>}
 */
export function approveByLegal(data) {
  return request({
    url: `${baseService}/api/invoice/sign/approveByLegal`,
    method: 'post',
    data
  })
}

/**
 * @function 法务拒绝签约
 * @param {object} data - 请求参数
 * @param {string[]} data.signIds - 签约号数组
 * @param {string} data.approvalRemark - 审核意见
 * @returns {Promise<object>}
 */
export function rejectByLegal(data) {
  return request({
    url: `${baseService}/api/invoice/sign/rejectedByLegal`,
    method: 'post',
    data
  })
}

/**
 * @function 合同作废
 * @param {object} data - 请求参数
 * @param {string[]} data.signIds - 签约号数组
 * @returns {Promise<object>}
 */
export function cancelSign(data) {
  return request({
    url: `${baseService}/api/invoice/sign/cancel`,
    method: 'post',
    data
  })
}

/**
 * @function 导入批量入库信息
 * @param {FormData} data - 文件FormData
 * @returns {Promise<object>}
 */
export function importInboundInfo(data) {
  return request({
    url: `${baseService}/api/invoice/info/importInboundInfo`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * @function 删除开票额度
 * @param {number} id - 开票额度ID
 * @returns {Promise<object>}
 */
export function removeInvoiceInfo(id) {
  return request({
    url: `${baseService}/api/invoice/info/removeById/${id}`,
    method: 'delete'
  })
}

/**
 * @function 获取用户的签约公司
 * @param {number} invoiceId - 发票ID
 * @returns {Promise<object>}
 */
export function getSignCompanyNameByInvoiceId(invoiceId) {
  return request({
    url: `${baseService}/api/invoice/info/getSignCompanyName/${invoiceId}`,
    method: 'get'
  })
}

/**
 * @function 根据合同编号下载合同PDF
 * @param {string} docNo - 合同编号
 * @returns {Promise<Blob>} PDF文件Blob数据
 */
export function downloadContractByDocNo(docNo) {
  return request({
    url: `${baseService}/api/invoice/sign/downLoadByDocNo`,
    method: 'get',
    params: { docNo },
    responseType: 'blob'
  })
}

/**
 * @function 查询商户信息
 * @param {object} userAccount - 请求参数
 * @param {string} userAccount - 商户ID
 * @returns {Promise<object>}
 */
export function getMerchantInfo(userAccount) {
  return request({
    url: `${baseService}/api/invoice/sign/queryUserAccount/${userAccount}`,
    method: 'get'
  })
}

/**
 * @function 查询商户可签约公司
 * @param {object} userAccount - 请求参数
 * @param {string} userAccount - 商户ID
 * @returns {Promise<object>}
 */
export function getMerchantSignCompany(userAccount) {
  return request({
    url: `${baseService}/api/invoice/sign/queryAllowCompany/${userAccount}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/invoiceManagement.js